<script>
import { mapActions } from 'vuex';
import BaseSelectFilter from '@/modules/_global/_components/filters/BaseSelectFilter.vue';

export default {
  name: 'LanguageSelect',

  extends: BaseSelectFilter,

  methods: {
    ...mapActions('localization', ['retrieveLanguages']),

    getData() {
      return this.retrieveLanguages().then(({ data }) => {
        return data;
      });
    }
  }
};
</script>
